// extracted by mini-css-extract-plugin
module.exports = {"root":"produtores_root__2BWqa"};